// The University of La Verne's undergraduate majors (#2743). Read on
// 2026-10-01 from the official 2026-2027 Catalog (catalog.laverne.edu): each
// college's undergraduate pages and their departments list the bachelor's
// programs, and every one is kept here, grouped by college; minors,
// certificates, the associate degree and graduate programs are left out. The
// College of Health and Community Well-Being sits at /college-public-health/
// in the catalog. Degree abbreviations are the catalog's own (BA, BS, BA/BS
// where one major offers both); Public Administration is written "BS"
// without parentheses and the Bachelor of Law and Public Service names its
// degree in full. Business Administration (BA) is listed under Business
// Majors as the catalog lists it (the catalog files it with the regional
// campus and accelerated adult programs). The integrated teacher preparation
// program's en dash is typed as a comma. The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "university-of-la-verne",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in the University of La Verne's official 2026-2027 Catalog, grouped by the college that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "University of La Verne 2026-2027 Catalog, College of Arts and Sciences",
                "url": "https://catalog.laverne.edu/college-arts-sciences/undergraduate/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA/BS"
                },
                {
                    "name": "Communications",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Create Your Own Major",
                    "degree": "BA/BS"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice & Criminology",
                    "degree": "BS"
                },
                {
                    "name": "Criminology",
                    "degree": "BS"
                },
                {
                    "name": "Digital Media",
                    "degree": "BA"
                },
                {
                    "name": "E-Commerce",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "International Business and Language",
                    "degree": "BS"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Legal Studies",
                    "degree": "BS"
                },
                {
                    "name": "Liberal Arts",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA/BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy/Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Photography",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA/BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Rhetoric and Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Social Science",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "University of La Verne 2026-2027 Catalog, College of Business",
                "url": "https://catalog.laverne.edu/college-business-public-management/undergraduate/business-majors/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration",
                    "degree": "BA"
                },
                {
                    "name": "Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Organizational Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Health and Community Well-Being",
            "source": {
                "label": "University of La Verne 2026-2027 Catalog, College of Health and Community Well-Being",
                "url": "https://catalog.laverne.edu/college-public-health/"
            },
            "majors": [
                {
                    "name": "Health Administration",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "LaFetra College of Education",
            "source": {
                "label": "University of La Verne 2026-2027 Catalog, LaFetra College of Education",
                "url": "https://catalog.laverne.edu/lafetra-college-education/undergraduate/"
            },
            "majors": [
                {
                    "name": "Child Development",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BA"
                },
                {
                    "name": "Integrated Teacher Preparation Program, Elementary Education + Credential",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Law and Public Service",
            "source": {
                "label": "University of La Verne 2026-2027 Catalog, College of Law and Public Service",
                "url": "https://catalog.laverne.edu/college-law/"
            },
            "majors": [
                {
                    "name": "Law and Public Service",
                    "degree": "Bachelor of Law and Public Service"
                },
                {
                    "name": "Public Administration",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
